// src/components/FullPageLoader.jsx
import { Box, CircularProgress } from '@mui/material';

export default function FullPageLoader() {
    return (
        <Box
            sx={{
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                height:'100vh',
            }}
        >
            <CircularProgress size={56} />
        </Box>
    );
}
